import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import CustomEventCalendar from "./CustomEventCalendar";
import omitDeep from "omit-deep-lodash";
import { uniqueId } from "lodash";
import { getAllData } from "../../../utils/helpers/fetching";
import {
  GET_BOOKING_ENTRIES_BY_SITE_AND_INVENTORY_ID,
  INFORMATION_BOOKINGS_BY_SITE,
  INFORMATION_BOOKING_IDS_BY_BATCH_ID,
} from "../../../gql/bookingapi";
import { compose, withApollo } from "react-apollo";
import { connect, useSelector, useDispatch } from "react-redux";
import { CustomFilterContext } from "../../booking-instruments/booking-instruments-custom-filter/context";
import {
  ATTRIBUTES_HEADING,
  BACKDROP_ZINDEX,
  CLUSTER_DETAILS_ATTRIBUTE_META,
  CLUSTER_DETAILS_HEADING,
  entryType,
  EQUIPMENT_DETAILS_HEADING,
  EVENT,
  IconStatus,
  INFORMATION_BOOKING_COLOR,
  INFORMATION_BOOKING_FCOLOR,
  INFORMATION_BOOKING_DESCRIPTION_MAX,
  INFORMATION_BOOKING_TYPE,
  NO_EQUIPMENT_FOR_FILTER,
  RESOURCE,
  singleEventSkeleton,
  STANDALONE_ATTRIBUTE_META,
  TIMELINE_BUFFER_UNITS,
} from "../../../constants";
import { loadBookingInstruments as loadBookingInstrumentsAction } from "../../booking-instruments/redux/actions";
import { loadPendingReservations as loadPendingReservationsAction } from "../../booking-calendars/redux/actions";
import { setForceInformationOnly } from "../../booking-calendars/redux/actions";
import { detectOverlapWithRegularBookings, detectOverlapWithinPending } from "./overlapDetection.utils";
import { changeDateToUtcString, formatUserDisplay } from "../../../utils/helpers/text";
import { OwcButton } from "@one/react";
import { toast } from "@mobiscroll/react";
import BackdropPortal from "../../../components/shared/BackdropPortal";
import PopOverModal from "../../../components/shared/CommonPopOverModal/PopOverModal";
import useDialog from "../../../utils/hooks/useDialog";
import PopOverClusterAgGridTable from "../../../components/shared/CommonPopOverModal/PopOverClusterAgGridTable";
import PopoverBookingStatusDetail from "../../../components/shared/CommonPopOverModal/PopoverBookingStatusDetail";
import PopoverAttributesDetails from "../../../components/shared/CommonPopOverModal/PopoverAttributesDetails";
import PopoverBookingTitle from "../../../components/shared/CommonPopOverModal/PopoverBookingTitle";
import { BookingContext } from "../../booking/context";
import { PaginationContext } from "../../../components/shared/pagination/PaginationContext";
import { useFormikContext } from "formik";
import { GET_BOOKING_ENTRIES_BY_BOOKING_ID } from "../../../gql/bookingapi/queries";
import moment from "moment/moment";
import { useHistory } from "react-router-dom";
import { getEquipment } from "../../../utils/helpers/fetching";
import { getShortIdentifier } from "@digitallab/grid-common-frontend-components";
import ConfirmDialog from "../../../components/shared/ConfirmDialog";
import BookingNotificationStatus from "../../booking-calendars/booking-notification-status/BookingNotificationStatus";
import { DROP_BOOKING } from "../../../gql/bookingapi/mutations";
import { UPDATE_BOOKING } from "../../../gql/bookingapi/mutations";
import { CREATE_INFORMATION_BOOKING, DELETE_INFORMATION_BOOKING } from "../../../gql/bookingapi/mutations";
import { UPDATE_REQUEST, BOOKING_ADMIN, BOOKING_CONFIG } from "../../../constants";
import { hasAllRequiredRoles } from "../../../utils/hooks/withRoles";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import { BOOKING_OPERATIONS } from "../../booking-operations";
import { quickEditTracker } from "../../booking-operations/quickEditTracker";
import { Auth } from "aws-amplify";
import RecurringBookingContext from "./RecurringBooking/Context/RecurringBookingContext";
import { useLocation } from "react-router-dom";
import {
  getAvailableRangesForEquipment,
  getBaseReservationsForEventDetails,
  getQuickEditReservations,
  getReservationDataInRange,
  getUnreservedIntervalsForEventDetails,
  hasValidReservationList,
} from "./getEventDetails.utils";
import { getCancelOperationStatus, resolveEquipmentListForCalendarRefresh } from "./calendarRefresh.utils";
import {
  buildHazardousTimelineEditState,
  buildTimelineMutationVariables,
  getTimelineUpdateContext,
} from "./timelineBookingUpdate.utils";
import CidmGroupDialog from "../../equipment-list/cidmGroupDialog";
import isUserCreatorParticipantOrAdmin from "../../../utils/helpers/user/isUserCreatorParticipantOrAdmin";
import { getPreviousHalfHourLabel, isBookingOngoingInTimezone, isEndType } from "../../../utils/helpers/dropBooking";
import { deriveShortDescription } from "../../../components/shared/RichDescription";
import { findUserByPrefillIdentity } from "../../bookings/groupViewPrefill.utils";

export const getAssistantUsers = (assistant) => {
  if (Array.isArray(assistant)) return assistant;
  if (assistant) return [assistant];
  return [];
};

const transformElnIdForMutation = (elnId) => {
  if (!elnId || typeof elnId !== "object") return null;

  if (elnId.eid) {
    const transformed = { eid: elnId.eid };
    if (elnId.name) transformed.name = elnId.name;
    return transformed;
  }

  if (elnId.name) {
    return { name: elnId.name };
  }

  return null;
};

const getBookingRange = (entries, startKey, endKey, fallbackStart, fallbackEnd) => {
  const startValues = entries.map((entry) => entry[startKey]).filter(Boolean);
  const endValues = entries.map((entry) => entry[endKey]).filter(Boolean);

  return {
    dateFrom: startValues.length
      ? new Date(Math.min(...startValues.map((value) => new Date(value).getTime()))).toISOString()
      : fallbackStart,
    dateTo: endValues.length
      ? new Date(Math.max(...endValues.map((value) => new Date(value).getTime()))).toISOString()
      : fallbackEnd,
  };
};

export const filterMyBookingsTimelineData = (resultArray, userId, userEmail) => {
  return resultArray.filter((result) => {
    const reservedForUsers = Array.isArray(result?.reservedForUsers) ? result.reservedForUsers : [];
    const reservedForEmails = Array.isArray(result?.reservedForEmails) ? result.reservedForEmails : [];
    const assistantUsers = getAssistantUsers(result?.bookingApprovalInfo?.assistent);
    const isCreator = result?.createdBy === userId || result?.createdByEmail === userEmail;

    return (
      reservedForUsers.includes(userId) || reservedForEmails.includes(userEmail) || assistantUsers.includes(userId) || isCreator
    );
  });
};

export const filterBySigneeOrMyBookingsMode = ({ resultArray, signeeFilter, myBookingsMode, userId, userEmail }) => {
  if (signeeFilter && signeeFilter.username !== "") {
    return resultArray.filter(
      (result) => result.isInformationBooking || result.reservedForEmails.includes(signeeFilter.email),
    );
  }

  if (myBookingsMode) {
    const myBookings = filterMyBookingsTimelineData(resultArray, userId, userEmail);
    const seenIds = new Set(myBookings.map((b) => b?.id).filter(Boolean));
    const extraInformation = resultArray.filter((r) => r?.isInformationBooking && r?.id && !seenIds.has(r.id));
    return [...myBookings, ...extraInformation];
  }

  return resultArray;
};

const CANCEL_INFORMATION_LABEL = "Cancel Information booking";
const CANCEL_BOOKING_TITLE = "Cancel booking";
const DROP_BOOKING_LABEL = "Drop booking";
const CANCEL_BOOKING_REASON_PROMPT = "Please add reason for canceling booking";
const END_BOOKING_TITLE = "End booking now";
const END_BOOKING_PROMPT = "Do you want to end this booking earlier than planned?";
const CANCEL_INFORMATION_BATCH_CONFIRMATION =
  "This slot is part of a batch. Cancelling it will cancel every Information slot in the same batch. Continue?";
const CANCEL_INFORMATION_SINGLE_CONFIRMATION = "Are you sure you want to cancel this Information booking?";

const buildBookingEntriesFilter = ({ dateFrom, dateTo, isEditMode, editBookingData, isDuplicate }) => {
  const filter = {
    and: [
      { active: { eq: true } },
      {
        or: [{ start: { le: dateTo } }, { end: { ge: dateFrom } }],
      },
    ],
  };

  if (isEditMode && editBookingData?.id) {
    filter.and.push({ bookingId: { ne: editBookingData.id } });
  }

  if (isDuplicate && filter.and) {
    filter.and = filter.and.filter((f) => !f.bookingId);
  }

  return filter;
};

const CalendarMainPage = ({
  client,
  loadBookingInstruments,
  loadPendingReservations,
  selectedStartDate,
  setSelectedStartDate,
  selectedEndDate,
  setSelectedEndDate,
  tabList,
  setTabList,
  view,
  setView,
  calView,
  setCalView,
  newEquipmentIds,
  setNewEquipmentIds,
  cancelStatus = false,
  setCancelStatus,
  deleteResourceId,
  setDeleteResourceId,
  isEquipmentView = false,
  isTimelineView,
  user: propUser = null,
  setPopupEnableStatus = () => {},
  visibleDatePicker = true,
  signeeFilter = null,
  isGroupView = false,
  listGroupByView,
  setListGroupByView,
  myBookingsMode = false,
  timelineGroupByDefault = "category",
  timelineGroupByStorageKey,
  timelineTimeframeStorageKey,
  timelineStorageOptions,
  isBookingWizard = false,
  groupViewPrefill = null,
}) => {
  const formik = useFormikContext();
  const {
    isEditMode,
    isDuplicate,
    isOngoing,
    editBookingData,
    dispatchAction: bookingDispatchAction,
  } = useContext(BookingContext);
  const { openDialog, ...dialogProps } = useDialog();
  const [eventsData, setEventsData] = useState([]);
  const [resourceData, setResourceData] = useState([]);
  const [loading, setloading] = useState(false);
  const [selectionType, setSelectionType] = useState();
  const storeUser = useSelector((store) => store.user);
  const user = propUser || storeUser;
  const { pendingReservations } = useSelector((state) => state.reservations);
  const isTvMode = useSelector((state) => state?.bookingInstruments?.isTvMode);
  const dataTimeZone = "utc";
  const displayTimeZone = user?.timezone || "UTC";
  const bookingInstruments = useSelector((store) => store.bookingInstruments);
  const usersList = useSelector((state) => state.users.users);
  const { selectedList, setSelectedList } = useContext(CustomFilterContext);
  const [popoverObject, setPopoverObject] = useState({
    equipmentData: {},
    eventData: {},
  });
  const { dispatchAction, data } = useContext(PaginationContext);

  const history = useHistory();

  const [cancelOpen, setCancelOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [dropType, setDropType] = useState("cancel");
  const [isCancelling, setIsCancelling] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);
  const [isPopoverFetching, setIsPopoverFetching] = useState(false);
  const [bookingFetchError, setBookingFetchError] = useState(false);
  const [cidmDialogState, setCidmDialogState] = useState({
    open: false,
    groupName: "",
    cidmUrl: "",
    infoUrl: "",
  });
  const pendingModalRefreshRef = useRef(null);
  const [calendarKey, setCalendarKey] = useState(0);
  const cancellationCallbackRef = useRef(null);
  const cancellationOperationRef = useRef(BOOKING_OPERATIONS.CANCEL);
  const selectedListBackupRef = useRef(null);
  const isBookingAdmin = user?.roles?.some((role) => role === "BookingAdmin");
  const location = useLocation();
  const { isRecurringBooking } = useContext(RecurringBookingContext);
  const isRecurringBookingRef = useRef(isRecurringBooking);

  useEffect(() => {
    isRecurringBookingRef.current = isRecurringBooking;
  }, [isRecurringBooking]);

  useEffect(() => {
    const url = `${location.pathname}${location.search || ""}`;
    const shouldResetEdit = (url.includes("/bookings") || url.includes("/group-views")) && isEditMode;
    if (!shouldResetEdit) return;
    bookingDispatchAction({
      type: "editBookingData",
      payload: {
        isEditMode: false,
        editBookingData: null,
        isCreateMode: false,
      },
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const safeSetEventsData = useCallback((newEvents) => {
    if (!Array.isArray(newEvents)) {
      console.warn("CalendarMainPage: safeSetEventsData received non-array data", newEvents);
      return;
    }

    try {
      setEventsData(newEvents);
    } catch (error) {
      console.error("CalendarMainPage: Error setting events data", error);
    }
  }, []);

  const dispatch = useDispatch();

  // Keep `forceInformationOnly` in Redux in sync with the current overlap state
  // between pending reservations (new slots the admin is creating) and the
  // existing regular bookings shown on the calendar. When the admin proceeds
  // to step 3, ForWhomMainPage reads this flag and forces Information type.
  // Non-admin users keep the original blocking behaviour (handled by hasOverlap).
  //
  // TimelineBookingEvent reads this flag directly to demote pending slots to
  // 18px / top-of-row in real time -- because the flag is consumed at render
  // time (not used to mutate the event-data array), toggling it does NOT
  // force Mobiscroll to recompute the data prop, so mid-drag slots are not
  // snapped back to their previous position.
  useEffect(() => {
    if (!isBookingAdmin || isEditMode || isDuplicate || isRecurringBooking) {
      return undefined;
    }
    // Debounce the overlap detection: during drag/resize the pending
    // reservations array is updated on every mouse move, and running the
    // O(n^2) overlap pass + Redux dispatch synchronously on every tick is a
    // significant contributor to laggy drag. 100 ms is fast enough for the
    // demotion to feel instant when the mouse settles.
    const timerId = window.setTimeout(() => {
      // BE rejects duplicate Run/Action bookings on the same timeframe, so we
      // also force Information when two pending slots overlap each other on
      // the same resource (not only when they collide with an existing booking).
      const overlap =
        detectOverlapWithRegularBookings(pendingReservations, eventsData) ||
        detectOverlapWithinPending(pendingReservations);
      dispatch(setForceInformationOnly(overlap));
    }, 100);
    return () => window.clearTimeout(timerId);
  }, [isBookingAdmin, isEditMode, isDuplicate, isRecurringBooking, pendingReservations, eventsData, dispatch]);

  useEffect(() => {
    if (isTimelineView) {
      setEventsData([]);
      setSelectedList([]);
      loadPendingReservations([]);
    }
  }, [isTimelineView, setSelectedList, loadPendingReservations, loadBookingInstruments, setNewEquipmentIds]);

  const getExtendedTimelineDates = () => {
    if (!isEditMode && (!selectedStartDate || !selectedEndDate)) {
      return { extendedStartDate: null, extendedEndDate: null };
    }

    const baseStartDate = isEditMode ? editBookingData?.dateFrom : selectedStartDate;
    const baseEndDate = isEditMode ? editBookingData?.dateTo : selectedEndDate;

    if (!baseStartDate || !baseEndDate) {
      return { extendedStartDate: null, extendedEndDate: null };
    }

    let bufferUnits;
    let timeUnit;

    switch (view) {
      case "day":
        bufferUnits = TIMELINE_BUFFER_UNITS.DAY;
        timeUnit = "days";
        break;
      case "week":
        bufferUnits = TIMELINE_BUFFER_UNITS.WEEK;
        timeUnit = "days";
        break;
      case "month":
        bufferUnits = TIMELINE_BUFFER_UNITS.MONTH;
        timeUnit = "months";
        break;
      default:
        bufferUnits = TIMELINE_BUFFER_UNITS.DAY;
        timeUnit = "days";
    }

    const extendedStartDate = moment(baseStartDate).subtract(bufferUnits, timeUnit).toDate();
    const extendedEndDate = moment(baseEndDate).add(bufferUnits, timeUnit).toDate();

    return { extendedStartDate, extendedEndDate };
  };

  const { extendedStartDate, extendedEndDate } = getExtendedTimelineDates();

  const normalizeBookingTitles = (data) => {
    data.forEach((evt) => {
      evt.title = ((evt.type || evt.title) ?? "")
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/^./, (c) => c.toUpperCase());
    });
  };

  useEffect(() => {
    normalizeBookingTitles(eventsData);
  }, [eventsData]);

  useEffect(() => {
    if (pendingReservations.length === 0) {
      tabList[2].isDisable = true;
      setTabList([...tabList]);
    } else if (pendingReservations.length !== 0) {
      tabList[2].isDisable = false;
      setTabList([...tabList]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingReservations]);

  useEffect(() => {
    if (bookingInstruments.bookingInstruments.length > 0) {
      const tempResource = [];
      bookingInstruments.bookingInstruments.forEach((item) => {
        tempResource.push({
          ...item,
          name: item.shortIdentifier ? item.shortIdentifier : getShortIdentifier(item),
          id: item?.inventoryId,
          eventOverlap: false,
        });
      });

      tempResource.sort((a, b) => {
        const aName = a.name || "";
        const bName = b.name || "";
        return aName.localeCompare(bName);
      });

      setResourceData(tempResource);
    }
  }, [bookingInstruments.bookingInstruments]);

  useEffect(() => {
    if (!pendingModalRefreshRef.current || !popoverObject?.eventData?.bookingId) {
      return;
    }

    const { bookingId: targetBookingId, resource: targetResource } = pendingModalRefreshRef.current;

    let matchingEntry = null;

    if (targetBookingId && targetResource) {
      matchingEntry = eventsData.find(
        (entry) =>
          entry.bookingId === targetBookingId &&
          (entry.resource === targetResource || entry.inventoryId === targetResource),
      );
    } else if (targetBookingId) {
      matchingEntry = eventsData.find((entry) => entry.bookingId === targetBookingId);
    }

    if (matchingEntry) {
      setPopoverObject((prev) => {
        if (!prev?.eventData) return prev;

        const currentBookingId = prev.eventData.bookingId;
        const currentResource = prev.eventData.resource || prev.eventData.inventoryId;
        if (
          currentBookingId !== targetBookingId ||
          (targetResource && currentResource && currentResource !== targetResource)
        ) {
          pendingModalRefreshRef.current = null;
          return prev;
        }
        return {
          ...prev,
          eventData: {
            ...prev.eventData,
            id: matchingEntry.id,
            start: matchingEntry.start,
            end: matchingEntry.end,
            bookingApprovalInfo: matchingEntry.bookingApprovalInfo,
            description: matchingEntry.description,
            project: matchingEntry.project,
            redPandaProjects: matchingEntry.redPandaProjects,
            elnId: matchingEntry.elnId,
            reservedForEmails: matchingEntry.reservedForEmails,
            createdBy: matchingEntry.createdBy,
            createdByEmail: matchingEntry.createdByEmail,
            assistent: matchingEntry.bookingApprovalInfo?.assistent,
            assistentTime: matchingEntry.bookingApprovalInfo?.assistentTime,
            approval: matchingEntry.bookingApprovalInfo?.approval,
            checkInDone: matchingEntry.bookingApprovalInfo?.checkInDone,
            checkInRequired: matchingEntry.bookingApprovalInfo?.checkInRequired,
            checkInEndsAt: matchingEntry.bookingApprovalInfo?.checkInEndsAt,
            checkInStartsAt: matchingEntry.bookingApprovalInfo?.checkInStartsAt,
            hazardousDeclaration: matchingEntry.bookingApprovalInfo?.hazardousDeclaration,
            assistanceDeclaration: matchingEntry.bookingApprovalInfo?.assistanceDeclaration,
            bookingEntries: (prev.eventData.bookingEntries || []).map((entry) =>
              entry.id === matchingEntry.id ? matchingEntry : entry,
            ),
          },
        };
      });

      pendingModalRefreshRef.current = null;
    }
  }, [eventsData, popoverObject]);

  const clearPendingReservation = useCallback(() => {
    loadPendingReservations([]);
  }, [loadPendingReservations]);
  const updatePendingReservation = useCallback(
    (list) => {
      loadPendingReservations([...list]);
    },
    [loadPendingReservations],
  );

  const fetchBookingsForEquipmentList = useCallback(
    async ({ effectiveList, siteName, filter, dateFrom, dateTo }) => {
      let hasError = false;

      const inventoryIdSet = new Set(effectiveList);

      const informationDateFrom = dateFrom || new Date(Date.now() - 365 * 24 * 3600 * 1000).toISOString();
      const informationDateTo = dateTo || new Date(Date.now() + 365 * 24 * 3600 * 1000).toISOString();
      const informationPromise = (async () => {
        // Information slots are read-only context for every consumer of this
        // helper (main timeline AND the wizard step 2), so we fetch them
        // unconditionally. The previous `isTimelineView` guard was wrong: it
        // hid Information from the wizard, and routing around it via the
        // `isTimelineView` prop had a destructive side effect (the mount
        // effect at the top of CalendarMainPage clears selectedList when
        // isTimelineView is true, kicking the wizard back to step 1).
        try {
          const { items } = await getAllData({
            client,
            query: INFORMATION_BOOKINGS_BY_SITE,
            drillData: true,
            fetchPolicy: "no-cache",
            variables: {
              site: siteName,
              dateFrom: informationDateFrom,
              dateTo: informationDateTo,
              limit: 1000,
              nextToken: null,
            },
            dataPath: ["data", "informationBookingsBySite"],
            isTvMode,
          });
          const list = Array.isArray(items) ? items : [];
          return list;
        } catch (fetchError) {
          return [];
        }
      })();

      const [bookingResults, informationItems] = await Promise.all([
        Promise.all(
          effectiveList.map(async (inventoryId) => {
            try {
              const { items, error } = await getAllData({
                client,
                query: GET_BOOKING_ENTRIES_BY_SITE_AND_INVENTORY_ID,
                drillData: true,
                fetchPolicy: "no-cache",
                variables: {
                  inventoryId: { eq: inventoryId },
                  limit: 1000,
                  nextToken: null,
                  site: siteName,
                  filter,
                },
                dataPath: ["data", "bookingEntriesBySiteAndInventoryId"],
                isTvMode,
              });

              if (error) {
                hasError = true;
                return [];
              }

              return omitDeep(items || [], "recurring").filter((x) => x && x.start < x.end);
            } catch (itemError) {
              hasError = true;
              return [];
            }
          }),
        ),
        informationPromise,
      ]);

      // Map InformationBooking -> booking-entry shape so the timeline can render it
      // with the same Eventcalendar engine. The `isInformationBooking` flag drives
      // distinct visuals + hover + interaction rules in renderer/handlers.
      //
      const editingInformationId =
        isEditMode && editBookingData?.type === INFORMATION_BOOKING_TYPE
          ? editBookingData?.informationBookingId || editBookingData?.id || editBookingData?.bookingId
          : null;
      const informationAsEntries = informationItems
        .filter((info) => info && inventoryIdSet.has(info.inventoryId))
        .filter((info) => !editingInformationId || info.id !== editingInformationId)
        .map((info) => ({
          __typename: "BookingEntries",
          id: info.id,
          bookingId: info.id,
          // Propagated so cancel / edit handlers can decide single vs cascade
          // path without a separate lookup. Null when the slot was created
          // outside a batch (single-slot wizard path).
          batchId: info.batchId || null,
          inventoryId: info.inventoryId,
          resource: info.inventoryId,
          site: info.site,
          start: info.dateFrom,
          end: info.dateTo,
          date: info.date,
          type: INFORMATION_BOOKING_TYPE,
          title: INFORMATION_BOOKING_TYPE,
          description: info.description,
          // BOOK_LOG-7469053: propagate richDescription so the popup's
          // RichDescriptionRenderer can show formatted markdown. Without
          // this the popup would fall back to the stripped `description`
          // and the user would see raw markdown / no formatting.
          richDescription: info.richDescription ?? info.description ?? "",
          color: info.color || INFORMATION_BOOKING_COLOR,
          fcolor: info.fcolor || INFORMATION_BOOKING_FCOLOR,
          active: info.active !== false,
          editable: false,
          isFirstTimeUser: false,
          allDay: false,
          createdAt: info.createdAt,
          createdBy: info.createdBy,
          createdByEmail: info.createdByEmail,
          reservedForEmails: info.reservedForUsers || [],
          reservedForUsers: info.reservedForUsers || [],
          project: info.project || null,
          redPandaProjects: info.redPandaProjects || null,
          // Marker consumed by the timeline event renderer and overlap rules.
          isInformationBooking: true,
          informationBookingId: info.id,
          cssClass: "is-information-booking",
          order: 0,
        }));

      const regularEntries = bookingResults.flat().map((entry) => ({
        ...entry,
        cssClass: [entry?.cssClass, "is-regular-booking"].filter(Boolean).join(" "),
        order: 100,
      }));

      return {
        hasError,
        resultArray: [...informationAsEntries, ...regularEntries],
      };
    },
    [client, isTvMode, isEditMode, editBookingData],
  );

  const getBookings = useCallback(
    async ({ siteName, dateFrom, dateTo, equipmentListOverride }) => {
      const effectiveList = equipmentListOverride || selectedList;
      if (!effectiveList || effectiveList.length === 0) {
        return { data: [], hasError: false };
      }

      const filter = buildBookingEntriesFilter({
        dateFrom,
        dateTo,
        isEditMode,
        editBookingData,
        isDuplicate,
      });

      try {
        const { hasError, resultArray } = await fetchBookingsForEquipmentList({
          effectiveList,
          siteName,
          filter,
          dateFrom,
          dateTo,
        });

        if (hasError) {
          return { data: [], hasError: true };
        }

        const filteredResults = filterBySigneeOrMyBookingsMode({
          resultArray,
          signeeFilter,
          myBookingsMode,
          userId: user?.user,
          userEmail: user?.email,
        });

        return { data: filteredResults, hasError: false };
      } catch (e) {
        return { data: [], hasError: true };
      }
    },
    [
      selectedList,
      isEditMode,
      editBookingData,
      isDuplicate,
      signeeFilter,
      myBookingsMode,
      user?.user,
      user?.email,
      fetchBookingsForEquipmentList,
    ],
  );

  const getReservationBooking = useCallback(
    async (dateFrom, dateTo, equipmentListOverride) => {
      try {
        const result = await getBookings({
          siteName: user?.site,
          dateFrom,
          dateTo,
          equipmentListOverride,
        });

        if (result.hasError) {
          setBookingFetchError(true);
          snackbarService.show({ message: "Unexpected Server Error", type: "error" });
          return result;
        }

        setBookingFetchError(false);
        const reservationData = result.data;

        if (!reservationData || !Array.isArray(reservationData)) {
          return { data: [], hasError: false };
        }

        reservationData.forEach((item) => {
          if (item) {
            item["editable"] = false;
            item["title"] = item?.type;
          }
        });
        return { data: reservationData, hasError: false };
      } catch (error) {
        setBookingFetchError(true);
        snackbarService.show({ message: "Unexpected Server Error", type: "error" });
        return { data: [], hasError: true };
      }
    },
    [getBookings, user],
  );

  // Helper: Create a base interval row with optional edit mode styling
  const createIntervalRow = useCallback(
    (start, end, resource, intervalRowConfiguration) => {
      let row = {
        ...singleEventSkeleton,
        id: uniqueId("available_"),
        start,
        end,
        resource,
      };

      if (isEditMode && intervalRowConfiguration) {
        row = {
          ...row,
          type: formik?.values?.bookingType,
          color: intervalRowConfiguration.backgroundColor,
          fcolor: intervalRowConfiguration.color,
          title: formik?.values?.bookingType,
        };
      }

      return row;
    },
    [isEditMode, formik?.values?.bookingType],
  );

  // Helper: Get interval row configuration for edit mode
  const getIntervalRowConfiguration = useCallback(() => {
    if (!isEditMode) return null;
    const row = IconStatus.find((x) => x.text === formik?.values?.bookingType);
    return row ?? null;
  }, [isEditMode, formik?.values?.bookingType]);

  // Helper: Get original equipment IDs from booking in edit mode
  const getOriginalEquipmentIds = useCallback(() => {
    if (!isEditMode || !editBookingData?.bookingEntries) return [];
    return editBookingData.bookingEntries.map((entry) => entry.inventoryId);
  }, [isEditMode, editBookingData]);

  // Helper: Check if equipment should be processed (skip newly added equipment in edit mode)
  const shouldProcessEquipment = useCallback(
    (item, originalEquipmentIds, includeNewEquipmentInEditMode = false) => {
      if (includeNewEquipmentInEditMode) return true;
      // istanbul ignore next - Covered by CalendarMainPage.test.js simulation tests
      return !isEditMode || originalEquipmentIds.includes(item);
    },
    [isEditMode],
  );

  // Helper: Create intervals for equipment without reservations
  const createIntervalsForUnreservedEquipment = useCallback(
    (
      activeEquipmentList,
      reservationData,
      startRange,
      endRange,
      originalEquipmentIds,
      intervalRowConfiguration,
      includeNewEquipmentInEditMode = false,
    ) => {
      const intervals = [];

      // Admins creating a new (non-edit, non-duplicate, non-recurring) booking are
      // allowed to overlap with existing regular bookings. The overlap is later
      // forced to Information type in step 3 via `forceInformationOnly`. For these
      // users we skip the gap-carving and emit the full selected range as a single
      // pending reservation per equipment so step 3 (`For what/whom?`) becomes
      // enabled even when the range is fully covered by existing bookings.
      const allowAdminOverlap = isBookingAdmin && !isEditMode && !isDuplicate && !isRecurringBookingRef.current;

      activeEquipmentList.forEach((item) => {
        // istanbul ignore next - Covered by CalendarMainPage.test.js simulation tests
        if (!shouldProcessEquipment(item, originalEquipmentIds, includeNewEquipmentInEditMode)) return;

        if (allowAdminOverlap) {
          intervals.push(createIntervalRow(startRange, endRange, item, intervalRowConfiguration));
          return;
        }

        const availableRanges = getAvailableRangesForEquipment({
          reservationData,
          equipmentId: item,
          startRange,
          endRange,
        });

        availableRanges.forEach((range) => {
          intervals.push(createIntervalRow(range.start, range.end, item, intervalRowConfiguration));
        });
      });

      return intervals;
    },
    [shouldProcessEquipment, createIntervalRow, isBookingAdmin, isEditMode, isDuplicate],
  );

  // Helper: Update state with computed intervals
  const updateStateWithIntervals = useCallback(
    (reservationList, tempInterval, onGoingEventList) => {
      if (!Array.isArray(reservationList) || !Array.isArray(tempInterval)) {
        console.error("CalendarMainPage: Invalid data structure for setEventsData", {
          reservationList,
          tempInterval,
        });
        return;
      }

      safeSetEventsData([...reservationList, ...tempInterval]);

      if (isEditMode && isOngoing) {
        loadPendingReservations([...onGoingEventList, ...tempInterval]);
      } else {
        loadPendingReservations([...tempInterval]);
      }
    },
    [safeSetEventsData, loadPendingReservations, isEditMode, isOngoing],
  );

  // isRecurringBooking is used in this function to allow for overlapping events when recurring booking is created by user.
  // Recurring bookings with conflicts (overlap) are blocked from being saved.
  // Single (non-recurring) bookings should be handled as usual. RETINA-5685174
  const getEventDetails = useCallback(
    ({
      startDate,
      endDate,
      reservationList = [],
      onGoingEventList = [],
      equipmentListOverride = null,
      isQuickEdit = false,
      includeNewEquipmentInEditMode = false,
    } = {}) => {
      // Handle case when no date range is provided
      if (!startDate || !endDate) {
        if (!hasValidReservationList(reservationList)) {
          console.error("CalendarMainPage: Invalid reservationList for setEventsData (no dates)", { reservationList });
          return;
        }

        safeSetEventsData([...reservationList]);
        updatePendingReservation([]);
        return;
      }

      const currentIsRecurring = isRecurringBookingRef.current;
      const startRange = changeDateToUtcString(startDate);
      const endRange = changeDateToUtcString(endDate);

      const normalizedReservationList = reservationList || [];
      const reservationData = getReservationDataInRange({
        reservationList: normalizedReservationList,
        startRange,
        endRange,
        currentIsRecurring,
      });
      const baseReservations = getBaseReservationsForEventDetails({
        reservationList: normalizedReservationList,
        reservationData,
        currentIsRecurring,
      });

      if (isQuickEdit) {
        const quickReservations = getQuickEditReservations({
          baseReservations,
          refreshTarget: pendingModalRefreshRef.current,
        });

        updateStateWithIntervals(quickReservations, [], onGoingEventList);
        return;
      }

      const activeEquipmentList = equipmentListOverride || selectedList;
      const originalEquipmentIds = getOriginalEquipmentIds();
      const intervalRowConfiguration = getIntervalRowConfiguration();

      const unreservedIntervals = getUnreservedIntervalsForEventDetails({
        isTimelineView,
        createIntervalsForUnreservedEquipment,
        activeEquipmentList,
        reservationData,
        startRange,
        endRange,
        originalEquipmentIds,
        intervalRowConfiguration,
        includeNewEquipmentInEditMode,
      });

      updateStateWithIntervals(reservationList, unreservedIntervals, onGoingEventList);
    },
    [
      selectedList,
      safeSetEventsData,
      updatePendingReservation,
      getOriginalEquipmentIds,
      getIntervalRowConfiguration,
      createIntervalsForUnreservedEquipment,
      updateStateWithIntervals,
      isTimelineView,
    ],
  );

  const getLatestEventDetailsOnly = useCallback(
    (startDate, endDate, reservationList, newSelectedList = []) => {
      if (!startDate || !endDate) return;

      const startRange = changeDateToUtcString(startDate);
      const endRange = changeDateToUtcString(endDate);
      const latestSelectedList = newSelectedList.filter((x) => selectedList.indexOf(x) !== -1);

      // No equipment to process - just update state with existing data
      if (latestSelectedList.length === 0) {
        safeSetEventsData([...reservationList, ...pendingReservations]);
        return;
      }

      const originalEquipmentIds = getOriginalEquipmentIds();
      const intervalRowConfiguration = getIntervalRowConfiguration();

      // Filter reservations to only include those for the selected equipment
      const filteredReservationList = reservationList.filter((x) => latestSelectedList.indexOf(x.resource) !== -1);

      // Get reservations within the date range
      const baseReservationData = filteredReservationList.filter((x) => x.end >= startRange && x.start <= endRange);
      const pendingInRange = pendingReservations.filter(
        (x) => x.end >= startRange && x.start <= endRange && latestSelectedList.indexOf(x.resource) !== -1,
      );
      const reservationData = [...baseReservationData, ...pendingInRange];

      // Create intervals for equipment without reservations
      const unreservedIntervals = createIntervalsForUnreservedEquipment(
        latestSelectedList,
        reservationData,
        startRange,
        endRange,
        originalEquipmentIds,
        intervalRowConfiguration,
      );

      safeSetEventsData([...reservationList, ...unreservedIntervals, ...pendingReservations]);
      loadPendingReservations([...pendingReservations, ...unreservedIntervals]);
    },
    [
      selectedList,
      safeSetEventsData,
      pendingReservations,
      getOriginalEquipmentIds,
      getIntervalRowConfiguration,
      createIntervalsForUnreservedEquipment,
      loadPendingReservations,
    ],
  );

  const removeEquipmentAndReservation = useCallback(
    (resourceId, pendingReservationsList) => {
      const tempEventData = eventsData.filter((x) => x.resource !== resourceId);
      const tempResourceData = resourceData.filter((x) => x.id !== resourceId);
      safeSetEventsData(tempEventData);
      setResourceData(tempResourceData);
      setSelectedList(selectedList.filter((x) => x !== resourceId));
      updatePendingReservation(pendingReservationsList.filter((x) => x.resource !== resourceId));
      loadBookingInstruments({
        bookingInstruments: bookingInstruments.bookingInstruments.filter((x) => x.inventoryId !== resourceId),
      });
    },
    [
      eventsData,
      resourceData,
      safeSetEventsData,
      setResourceData,
      selectedList,
      setSelectedList,
      updatePendingReservation,
      loadBookingInstruments,
      bookingInstruments,
    ],
  );

  const manipulatePopoverContent = useCallback(
    async ({ userSelectionType, resourceId = null, eventId = null }) => {
      setSelectionType(userSelectionType);

      if (selectedList && selectedList.length > 0) {
        selectedListBackupRef.current = [...selectedList];
      }

      switch (userSelectionType) {
        case EVENT:
          if (eventId) {
            // Cancel any pending refresh from a previously viewed booking to prevent
            // its stale data from overwriting this new booking's modal content.
            pendingModalRefreshRef.current = null;

            let eventData = eventsData.find((x) => x.id === eventId);
            if (!eventData) {
              return;
            }

            setIsPopoverFetching(true);
            try {
              const equipmentData = await getEquipment({
                inventoryId: eventData.resource,
                client,
              });

              if (!equipmentData) {
                setIsPopoverFetching(false);
                return;
              }

              setIsPopoverFetching(false);
              openDialog();
              const relatedEntries = Array.isArray(eventsData)
                ? eventsData.filter((e) => e?.bookingId && e.bookingId === eventData.bookingId)
                : [];
              const bookedEquipments = Array.from(
                new Set(relatedEntries.map((e) => e?.equipment?.shortIdentifier || e?.resource).filter(Boolean)),
              );

              const finalEventData = {
                ...eventData,
                bookingEntries: relatedEntries,
                ...eventData.bookingApprovalInfo,
              };

              setPopoverObject({
                equipmentData: {
                  ...equipmentData,
                  bookedEquipments,
                },
                eventData: finalEventData,
              });
            } catch (error) {
              setIsPopoverFetching(false);
              console.error("Error fetching equipment data:", error);
            }
          }

          break;
        case RESOURCE:
          if (resourceId) {
            setIsPopoverFetching(true);
            try {
              const equipmentData = await getEquipment({
                inventoryId: resourceId,
                client,
              });

              if (!equipmentData) {
                setIsPopoverFetching(false);
                return;
              }

              const eventData = {};
              setIsPopoverFetching(false);
              openDialog();
              setPopoverObject({
                equipmentData: equipmentData,
                eventData: eventData,
              });
            } catch (error) {
              setIsPopoverFetching(false);
              console.error("Error fetching equipment data:", error);
            }
          }
          break;

        default:
          break;
      }
    },
    [selectedList, eventsData, client, openDialog],
  );

  const emailToBookingForObj = useCallback(
    (email) => {
      const found = usersList.find((u) => u.email === email);
      return found
        ? {
            ...found,
            key: found.email,
            value: formatUserDisplay(found),
          }
        : {
            key: email,
            userId: null,
            email,
            name: email,
            givenName: "",
            familyName: "",
            value: email,
          };
    },
    [usersList],
  );

  const userIdToBookingForObj = useCallback((userId) => {
    const found = findUserByPrefillIdentity(usersList, userId);
    if (found) {
      return {
        ...found,
        key: found.email || found.user || found.userId,
        userId: found.user || found.userId,
        value: formatUserDisplay(found),
      };
    }

    const fallbackId = String(userId || "").trim();
    if (!fallbackId) return null;

    return {
      key: fallbackId,
      userId: fallbackId,
      email: fallbackId.includes("@") ? fallbackId : "",
      name: fallbackId,
      givenName: "",
      familyName: "",
      value: fallbackId,
    };
  }, [usersList]);

  const buildGroupViewPrefillDraft = useCallback((prefill) => {
    if (!prefill) return null;

    // The assistant is a separate role from the booking's participants -- it
    // must not be merged into bookingFor/reservedForUsers, only stored on its
    // own `assistant` field below.
    const mergedBookingFor = (prefill.users || [])
      .map(userIdToBookingForObj)
      .filter(Boolean)
      .filter((item, index, items) => {
        const dedupeKey = String(item.userId || item.email || "").toLowerCase();
        if (!dedupeKey) return false;

        return index === items.findIndex((other) => {
          const otherKey = String(other.userId || other.email || "").toLowerCase();
          return otherKey === dedupeKey;
        });
      });
    const redPandaProjects = (prefill.projectIds || []).map((projectId) => ({ projectId }));
    const richDescription = prefill.richDescription || "";
    const description = deriveShortDescription(richDescription, INFORMATION_BOOKING_DESCRIPTION_MAX);
    const hasPrefilledAssistance = Boolean(prefill.assistance);
    const hasPrefilledHazardous = Boolean(prefill.material);

    return {
      bookingFor: mergedBookingFor,
      bookedUsers: mergedBookingFor,
      reservedForUsers: mergedBookingFor.map((item) => item.userId).filter(Boolean),
      reservedForEmails: mergedBookingFor.map((item) => item.email).filter(Boolean),
      redPandaProjects,
      project: redPandaProjects.length > 0 ? "" : (prefill.project || ""),
      description,
      withAssistance: hasPrefilledAssistance ? true : undefined,
      assistant: prefill.assistant || null,
      assistanceReason: prefill.assistanceReason || "",
      material: prefill.material || "",
      // No material specified -> initialize the declaration as non-hazardous
      // (toggle on/safe); specified -> keep the text and untoggle (hazardous).
      hasHazardousMaterials: hasPrefilledHazardous,
      hazardousMaterialsText: hasPrefilledHazardous ? (prefill.material || "") : "",
      originId: prefill.originId || "",
      richDescription,
    };
  }, [userIdToBookingForObj]);

  const editBooking = async (editData) => {
    let editDataClone = eventsData.find((x) => x.bookingId === editData.bookingId);

    editDataClone["bookedEquipments"] = [editDataClone.equipment?.shortIdentifier];
    editDataClone["dateFrom"] = editDataClone.start;
    editDataClone["dateTo"] = editDataClone.end;
    editDataClone.id = editDataClone.bookingId;

    const extraFieldsToRemove = [
      "allDay",
      "color",
      "editable",
      "createdAt",
      "end",
      "expiresAt",
      "fcolor",
      "recurringException",
      "recurringExceptionRule",
      "resource",
      "site",
      "start",
      "timezone",
      "title",
    ];
    extraFieldsToRemove.forEach((k) => delete editDataClone[k]);

    const currentTimeString = moment.tz(user.timezone).utc().format();
    dispatchAction({
      type: "fetching",
      payload: true,
    });

    const { items } = await getAllData({
      client,
      query: GET_BOOKING_ENTRIES_BY_BOOKING_ID,
      drillData: true,
      fetchPolicy: "no-cache",
      variables: {
        bookingId: editDataClone.bookingId,
        nextToken: null,
        filter: { active: { eq: true } },
      },
      dataPath: ["data", "bookingEntriesByBookingId"],
    });
    if (items.length > 0) {
      const keyArray = Object.keys(singleEventSkeleton);
      editDataClone["bookingEntries"] = items.map((item) => {
        if (new Date(item.start) < new Date(editDataClone["dateFrom"])) {
          editDataClone["dateFrom"] = item.start;
        }
        if (new Date(item.end) > new Date(editDataClone["dateTo"])) {
          editDataClone["dateTo"] = item.end;
        }
        let tempObj = {};
        keyArray.forEach((key) => {
          tempObj = {
            ...tempObj,
            [key]: item[key] ?? null,
          };
        });
        tempObj = {
          ...tempObj,
          inventoryId: item.resource,
          equipment: item.equipment,
          title: item.type,
          description: item?.description,
          elnId: item?.elnId,
          project: item?.project,
          redPandaProjects: item?.redPandaProjects,
          createdBy: item?.createdBy,
          reservedForEmails: item?.reservedForEmails,
        };
        return tempObj;
      });
      const bookedUsersList = (editDataClone.reservedForEmails || []).map(emailToBookingForObj);
      editDataClone.bookingFor = bookedUsersList;
      editDataClone.bookedUsers = bookedUsersList;
      if (items[0].elnId) editDataClone.elnId = items[0].elnId;
    }
    bookingDispatchAction({
      type: "editBookingData",
      payload: {
        isEditMode: true,
        keepLastUrlRedirect: true,
        editBookingData: editDataClone,
        isOngoing: currentTimeString > editDataClone.dateFrom && currentTimeString < editDataClone.dateTo,
      },
    });

    const tempBookingEntries = editDataClone?.bookingEntries.map((item) => {
      return {
        ...item,
        inventoryId: item.resource,
        isEditEventFlag: true,
        isOngoingEventFlag:
          (currentTimeString > item.end && currentTimeString > item.start) ||
          (currentTimeString > item.start && currentTimeString < item.end),
        editable: currentTimeString < item.end,
        title: item?.type,
      };
    });
    loadPendingReservations(tempBookingEntries);
    if (data) history.push("/");
  };

  const buildEntryFromSkeleton = useCallback((item, skeletonKeys) => {
    const entry = {};
    skeletonKeys.forEach((k) => {
      entry[k] = item[k] ?? null;
    });
    return entry;
  }, []);

  const resolveBookingEntryEquipment = useCallback((item, equipmentDetailsMap) => {
    const fetched = equipmentDetailsMap.get(item.resource);
    if (fetched) {
      return {
        ...fetched,
        id: fetched.inventoryId || item.resource,
      };
    }

    const fallbackIdentifier = item.equipment?.shortIdentifier || item.resource;
    const fallbackModel = item.equipment?.equipmentModel || fallbackIdentifier;
    return (
      item.equipment ?? {
        id: item.resource,
        shortIdentifier: fallbackIdentifier,
        equipmentModel: fallbackModel,
      }
    );
  }, []);

  const buildBookingEntry = useCallback(
    (item, skeletonKeys, equipmentDetailsMap) => {
      const baseEntry = buildEntryFromSkeleton(item, skeletonKeys);

      return {
        ...baseEntry,
        inventoryId: item.resource,
        equipment: resolveBookingEntryEquipment(item, equipmentDetailsMap),
        title: item.type,
        description: item.description ?? null,
        elnId: item.elnId ?? null,
        project: item.project ?? null,
        createdBy: item.createdBy ?? user?.user,
        reservedForEmails: item.reservedForEmails?.length > 0 ? item.reservedForEmails : [user?.email],
      };
    },
    [buildEntryFromSkeleton, resolveBookingEntryEquipment, user?.email, user?.user],
  );

  const handleCreateBookingFromEquipmentView = useCallback(async () => {
    try {
      if (!pendingReservations || pendingReservations.length === 0) {
        toast({ message: "Create time slots first" });
        return;
      }

      const starts = pendingReservations.map((r) => new Date(r.start)).filter(Boolean);
      const ends = pendingReservations.map((r) => new Date(r.end)).filter(Boolean);
      const dateFrom = starts.length ? new Date(Math.min.apply(null, starts)).toISOString() : null;
      const dateTo = ends.length ? new Date(Math.max.apply(null, ends)).toISOString() : null;

      const equipmentIds = Array.from(new Set(pendingReservations.map((r) => r.resource).filter((id) => !!id)));

      const equipmentDetailsMap = new Map();
      try {
        await Promise.all(
          equipmentIds.map(async (inventoryId) => {
            const eq = await getEquipment({
              inventoryId,
              client,
            });
            if (eq) {
              equipmentDetailsMap.set(inventoryId, eq);
            }
          }),
        );
      } catch (e) {
        console.error("Equipment details fetch failed, using fallbacks");
      }

      const skeletonKeys = Object.keys(singleEventSkeleton);
      const bookingEntries = pendingReservations.map((item) =>
        buildBookingEntry(item, skeletonKeys, equipmentDetailsMap),
      );

      const draftBookingData = {
        // Identify this as a draft without bookingId
        id: undefined,
        startAtStep: 3,
        bookingEntries,
        bookedEquipments: equipmentIds,
        dateFrom,
        dateTo,
        site: user?.site,
        type: null,
        description: "",
        project: "",
        redPandaProjects: [],
        createdBy: user,
        reservedForEmails: [user?.email],
        reservedForUsers: [user?.user],
        bookingFor: [
          {
            ...user,
            key: user?.email,
            value: formatUserDisplay(user),
          },
        ],
        bookedUsers: [
          {
            ...user,
            key: user?.email,
            value: formatUserDisplay(user),
          },
        ],
      };

      const prefillDraftData = isGroupView && groupViewPrefill
        ? buildGroupViewPrefillDraft(groupViewPrefill)
        : null;

      const nextDraftBookingData = prefillDraftData
        ? {
          ...draftBookingData,
          ...prefillDraftData,
          prefillSource: "group-view-url",
        }
        : draftBookingData;

      bookingDispatchAction({
        type: "editBookingData",
        payload: {
          isEditMode: true,
          keepLastUrlRedirect: true,
          editBookingData: nextDraftBookingData,
          isCreateMode: true,
          isOngoing: false,
          startAtStep: 3,
        },
      });

      updatePendingReservation([...pendingReservations]);

      history.push("/");
    } catch (e) {
      toast({ message: "Unable to start booking creation" });
    }
  }, [
    pendingReservations,
    user,
    updatePendingReservation,
    bookingDispatchAction,
    history,
    client,
    buildBookingEntry,
    isGroupView,
    groupViewPrefill,
    buildGroupViewPrefillDraft,
  ]);

  const loadTimelineEntryItems = useCallback(
    async (bookingId) => {
      const { items } = await getAllData({
        client,
        query: GET_BOOKING_ENTRIES_BY_BOOKING_ID,
        drillData: true,
        fetchPolicy: "no-cache",
        variables: {
          bookingId,
          nextToken: null,
          filter: { active: { eq: true } },
        },
        dataPath: ["data", "bookingEntriesByBookingId"],
        awsAppSyncConfig: BOOKING_CONFIG,
      });

      return items || [];
    },
    [client],
  );

  const getTimelineSourceEntryError = useCallback((bookingId, sourceEntry) => {
    if (!sourceEntry) {
      return "Edited slot not found";
    }

    if (sourceEntry.bookingId !== bookingId || sourceEntry.active === false) {
      return "Edited slot is not valid for update";
    }

    return null;
  }, []);

  const rerouteHazardousTimelineUpdate = useCallback(
    ({ bookingId, draft, entryId, entryItems, sourceEntry, sourceEvent, updatedEquipmentMeta }) => {
      const { editBookingData: hazardousEditBookingData, pendingReservations: reroutedPendingReservations } =
        buildHazardousTimelineEditState({
          bookingId,
          draft,
          emailToBookingForObj,
          entryId,
          entryItems,
          getBookingRange,
          singleEventSkeleton,
          sourceEntry,
          sourceEvent,
          updatedEquipmentMeta,
        });

      bookingDispatchAction({
        type: "editBookingData",
        payload: {
          isEditMode: true,
          isCreateMode: false,
          keepLastUrlRedirect: true,
          editBookingData: hazardousEditBookingData,
        },
      });

      loadPendingReservations(reroutedPendingReservations);
      history.push("/");
      return { rerouted: true };
    },
    [bookingDispatchAction, emailToBookingForObj, history, loadPendingReservations],
  );

  const submitTimelineBookingUpdate = useCallback(
    async (variables) => {
      try {
        const response = await client.mutate({
          mutation: UPDATE_BOOKING,
          fetchPolicy: "no-cache",
          variables,
        });

        const commandId = response?.data?.createBookingCommand?.id;
        if (commandId) {
          quickEditTracker.register(commandId, BOOKING_OPERATIONS.UPDATE);
        }

        try {
          await getReservationBooking(extendedStartDate, extendedEndDate);
        } catch (_e) {}

        return { rerouted: false };
      } catch (_error) {
        snackbarService.show({ message: "Booking update failed", type: "error" });
        return false;
      }
    },
    [client, extendedEndDate, extendedStartDate, getReservationBooking],
  );

  const handleTimelineUpdateBooking = useCallback(
    async ({ bookingId, entryId, original, draft, editedEntry }) => {
      if (!bookingId || !entryId || !draft) return false;

      if (editedEntry?.isInformationBooking) {
        const oldId = editedEntry.informationBookingId || editedEntry.bookingId;
        if (!oldId) {
          snackbarService.show({ message: "Information slot id missing", type: "error" });
          return false;
        }
        const newInventoryId = draft.resource || editedEntry.inventoryId || editedEntry.resource;
        const oldInventoryId = editedEntry.inventoryId || editedEntry.resource || original?.resource;
        const equipmentChanged = !!newInventoryId && !!oldInventoryId && newInventoryId !== oldInventoryId;
        const reservedForUsers = Array.isArray(editedEntry.reservedForUsers)
          ? editedEntry.reservedForUsers.filter(Boolean)
          : [];
        const redPandaProjects = Array.isArray(editedEntry.redPandaProjects)
          ? editedEntry.redPandaProjects.map(({ __typename, ...rest }) => rest)
          : [];
        const projectValue =
          typeof editedEntry.project === "string" && editedEntry.project.trim() ? editedEntry.project : null;
        const dateFromIso = moment(draft.start).utc().format();
        const dateToIso = moment(draft.end).utc().format();
        const siteValue = editedEntry.site || user?.site;

        try {
          if (!equipmentChanged) {
            // Same equipment -> in-place update (BE updates dateFrom/dateTo/date).
            await client.mutate({
              mutation: CREATE_INFORMATION_BOOKING,
              fetchPolicy: "no-cache",
              variables: {
                input: {
                  id: oldId,
                  description: editedEntry.description || "",
                  reservedForUsers,
                  project: projectValue,
                  redPandaProjects,
                  dateFrom: dateFromIso,
                  dateTo: dateToIso,
                  site: siteValue,
                  inventoryId: oldInventoryId || newInventoryId,
                  color: editedEntry.color || INFORMATION_BOOKING_COLOR,
                  fcolor: editedEntry.fcolor || INFORMATION_BOOKING_FCOLOR,
                },
              },
            });
          } else {
            // Equipment changed -> create new, then soft-delete old (BE doesn't
            // allow inventoryId mutation on update). Order is create-then-delete
            // so a failure of the second step doesn't lose the slot.
            await client.mutate({
              mutation: CREATE_INFORMATION_BOOKING,
              fetchPolicy: "no-cache",
              variables: {
                input: {
                  description: editedEntry.description || "",
                  reservedForUsers,
                  project: projectValue,
                  redPandaProjects,
                  dateFrom: dateFromIso,
                  dateTo: dateToIso,
                  site: siteValue,
                  inventoryId: newInventoryId,
                  color: editedEntry.color || INFORMATION_BOOKING_COLOR,
                  fcolor: editedEntry.fcolor || INFORMATION_BOOKING_FCOLOR,
                },
              },
            });
            try {
              await client.mutate({
                mutation: DELETE_INFORMATION_BOOKING,
                fetchPolicy: "no-cache",
                variables: { id: oldId },
              });
            } catch (deleteError) {
              snackbarService.show({
                message: "Moved slot created, but removing the original failed. Please delete it manually.",
                type: "warning",
              });
            }
          }
          snackbarService.show({ message: "Information slot updated", type: "success" });
          try {
            await getReservationBooking(extendedStartDate, extendedEndDate);
          } catch (_e) {
            /* refresh failure is non-critical */
          }
          return { rerouted: false };
        } catch (_error) {
          snackbarService.show({ message: "Failed to update information slot", type: "error" });
          return false;
        }
      }

      try {
        const entryItems = await loadTimelineEntryItems(bookingId);

        if (!entryItems.length) {
          snackbarService.show({ message: "Booking entries not found", type: "error" });
          return false;
        }

        const timelineContext = getTimelineUpdateContext({
          bookingId,
          bookingInstruments: bookingInstruments?.bookingInstruments || [],
          draft,
          editedEntry,
          entryId,
          entryItems,
          eventsData,
          original,
        });
        const { assistanceFalseToTrue, hazardousFalseToTrue, newMeta, sourceEntry, sourceEvent } = timelineContext;
        const sourceEntryError = getTimelineSourceEntryError(bookingId, sourceEntry);

        if (sourceEntryError) {
          snackbarService.show({ message: sourceEntryError, type: "error" });
          return false;
        }

        if (hazardousFalseToTrue) {
          return rerouteHazardousTimelineUpdate({
            bookingId,
            draft,
            entryId,
            entryItems,
            sourceEntry,
            sourceEvent,
            updatedEquipmentMeta: newMeta,
          });
        }

        const variables = buildTimelineMutationVariables({
          assistanceFalseToTrue,
          bookingId,
          draft,
          entryId,
          entryItems,
          getBookingRange,
          hasBookingAdminRole: hasAllRequiredRoles(user?.roles || [], [BOOKING_ADMIN]),
          sourceEntry,
          sourceEvent,
          transformElnIdForMutation,
          updateRequest: UPDATE_REQUEST,
          user,
        });

        return submitTimelineBookingUpdate(variables);
      } catch (_error) {
        snackbarService.show({ message: "Unable to load booking", type: "error" });
        return false;
      }
    },
    [
      client,
      eventsData,
      extendedEndDate,
      extendedStartDate,
      getReservationBooking,
      bookingInstruments,
      getTimelineSourceEntryError,
      loadTimelineEntryItems,
      user,
      rerouteHazardousTimelineUpdate,
      submitTimelineBookingUpdate,
    ],
  );

  const handleCancelCreateFlow = useCallback(() => {
    loadPendingReservations([]);
    setEventsData((prev) => (prev || []).filter((e) => !e.id?.startsWith("available_")));
  }, [loadPendingReservations]);

  const resetCancelState = useCallback(() => {
    setCancelOpen(false);
    setIsCancelling(false);
    setCancelReason("");
    setDropType("cancel");
    cancellationOperationRef.current = BOOKING_OPERATIONS.CANCEL;
  }, []);

  const resolveEquipmentList = useCallback(() => {
    const { equipmentList, shouldPersistSelection } = resolveEquipmentListForCalendarRefresh({
      selectedList,
      backupSelectedList: selectedListBackupRef.current || [],
      bookingInstruments: bookingInstruments.bookingInstruments || [],
    });

    if (shouldPersistSelection) {
      setSelectedList(equipmentList);
    }

    return equipmentList;
  }, [bookingInstruments.bookingInstruments, selectedList, setSelectedList]);

  const handleCancelSuccess = useCallback(async () => {
    try {
      const equipmentList = resolveEquipmentList();
      const reservationResult = await getReservationBooking(
        changeDateToUtcString(extendedStartDate),
        changeDateToUtcString(extendedEndDate),
        equipmentList,
      );

      if (reservationResult.hasError) {
        setBookingFetchError(true);
        resetCancelState();
        return;
      }

      getEventDetails({
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        reservationList: reservationResult.data || [],
        onGoingEventList: [],
        equipmentListOverride: equipmentList,
      });

      setCalendarKey((prev) => prev + 1);
      setTimeout(resetCancelState, 300);
    } catch (error) {
      console.error("Error refreshing data after cancellation:", error);
      resetCancelState();
    }
  }, [
    extendedEndDate,
    extendedStartDate,
    getEventDetails,
    getReservationBooking,
    resetCancelState,
    resolveEquipmentList,
    selectedEndDate,
    selectedStartDate,
  ]);

  const bookingCallback = useCallback(
    async (response) => {
      const expectedOperation = cancellationOperationRef.current || BOOKING_OPERATIONS.CANCEL;
      const { isCancelSuccess, isCancelFailure } = getCancelOperationStatus({
        response,
        cancelOperation: expectedOperation,
      });

      if (isCancelSuccess) {
        await handleCancelSuccess();
        return;
      }

      if (isCancelFailure) {
        setIsCancelling(false);
        setCancelReason("");
        try {
          snackbarService.show({
            type: "error",
            message:
              expectedOperation === BOOKING_OPERATIONS.END ? "Failed to end booking" : "Failed to cancel booking",
            duration: 3000,
          });
        } catch (_) {}
      }
    },
    [handleCancelSuccess],
  );

  const handleCancelBooking = async () => {
    const eventData = popoverObject?.eventData;
    const bookingId = eventData?.bookingId || eventData?.id;
    if (!bookingId) return;

    const isEndNowAction = isEndType(dropType) && !eventData?.isInformationBooking;
    const operationType = isEndNowAction ? BOOKING_OPERATIONS.END : BOOKING_OPERATIONS.CANCEL;
    cancellationOperationRef.current = operationType;

    if (eventData?.isInformationBooking) {
      setIsCancelling(true);
      try {
        const slotId = eventData?.informationBookingId || bookingId;
        const batchId = eventData?.batchId;
        if (batchId) {
          // Cascade cancel: resolve every active sibling id from the batch
          // GSI, then soft-delete them via the single-slot DELETE mutation.
          // BE has no atomic batchDelete; partial failures are reported.
          const idsResult = await client.query({
            query: INFORMATION_BOOKING_IDS_BY_BATCH_ID,
            fetchPolicy: "no-cache",
            variables: { batchId },
          });
          const ids = idsResult?.data?.informationBookingIdsByBatchId || [];
          if (ids.length === 0) {
            snackbarService.show({
              type: "error",
              message: "Batch is no longer available",
              duration: 3000,
            });
            setIsCancelling(false);
            setCancelReason("");
            setCancelOpen(false);
            return;
          }
          const results = await Promise.allSettled(
            ids.map((id) =>
              client.mutate({
                mutation: DELETE_INFORMATION_BOOKING,
                fetchPolicy: "no-cache",
                variables: { id },
              }),
            ),
          );
          const succeeded = results.filter((r) => r.status === "fulfilled").length;
          const failed = results.length - succeeded;
          if (succeeded === 0) {
            throw new Error("Failed to cancel Information batch");
          }
          let message;
          if (failed > 0) {
            message = `Cancelled ${succeeded} of ${results.length} Information slots (${failed} failed)`;
          } else if (succeeded > 1) {
            message = `Cancelled ${succeeded} Information slots`;
          } else {
            message = "Information booking cancelled";
          }
          snackbarService.show({
            type: failed > 0 ? "warning" : "success",
            message,
            duration: 3000,
          });
        } else {
          await client.mutate({
            mutation: DELETE_INFORMATION_BOOKING,
            fetchPolicy: "no-cache",
            variables: { id: slotId },
          });
          snackbarService.show({ type: "success", message: "Information booking cancelled", duration: 3000 });
        }
        dialogProps.close();
        setPopoverObject({});
        try {
          await handleCancelSuccess();
        } catch (_e) {
          /* refresh failure non-critical */
        }
      } catch (error) {
        try {
          snackbarService.show({ type: "error", message: "Failed to cancel Information booking", duration: 3000 });
        } catch (_) {}
      } finally {
        setIsCancelling(false);
        setCancelReason("");
        setCancelOpen(false);
      }
      return;
    }

    if (!isEndNowAction && !cancelReason) return;

    setIsCancelling(true);

    cancellationCallbackRef.current = async () => {
      await bookingCallback({ operation: operationType, success: true });
      dialogProps.close();
      setPopoverObject({});
    };

    try {
      const { username: id } = await Auth.currentAuthenticatedUser();
      await client.mutate({
        mutation: DROP_BOOKING,
        variables: {
          createdBy: id,
          bookingId,
          remark: isEndNowAction ? "End booking" : cancelReason,
          DROP_TYPE: isEndNowAction ? "END_REQUEST" : "CANCEL_REQUEST",
          ...(storeUser?.roles?.includes("BookingAdmin") ? { force: true } : {}),
        },
      });
    } catch (error) {
      console.error("Error cancelling booking:", error);
      cancellationCallbackRef.current = null;
      setCancelReason("");
      try {
        snackbarService.show({ type: "error", message: "Cancellation failed", duration: 3000 });
      } catch (_) {}
      setIsCancelling(false);
    }
  };

  const displayCancelBookingButton = () => {
    if (!isTimelineView) return null;

    const eventData = popoverObject?.eventData;
    if (!eventData || Object.keys(eventData).length === 0) return null;

    const userCanManageBooking = isUserCreatorParticipantOrAdmin(storeUser, eventData);
    const isInformation = !!eventData?.isInformationBooking;
    const isEndNowAllowed =
      !isInformation &&
      eventData?.active !== false &&
      isBookingOngoingInTimezone(eventData, storeUser?.timezone || "UTC");
    const buttonLabel = isInformation ? "Cancel Information booking" : isEndNowAllowed ? "End now" : "Cancel Booking";
    const nextDropType = isEndNowAllowed ? "end" : "cancel";

    if (userCanManageBooking) {
      return (
        <OwcButton
          variant={"secondary"}
          flat={!isEndNowAllowed}
          style={{ marginLeft: "20px" }}
          onClick={() => {
            setDropType(nextDropType);
            setCancelOpen(true);
          }}
        >
          {buttonLabel}
        </OwcButton>
      );
    }

    return null;
  };

  const handleQuickEditComplete = useCallback(async () => {
    try {
      // Set the pending refresh BEFORE loading data so the useEffect can catch it
      if (popoverObject?.eventData?.bookingId) {
        const bookingIdToRefresh = popoverObject.eventData.bookingId;
        const resourceToRefresh = popoverObject.eventData.resource || popoverObject.eventData.inventoryId;

        pendingModalRefreshRef.current = {
          bookingId: bookingIdToRefresh,
          resource: resourceToRefresh,
        };
      }

      const reservationResult = await getReservationBooking(
        changeDateToUtcString(extendedStartDate),
        changeDateToUtcString(extendedEndDate),
      );

      if (reservationResult.hasError) {
        setBookingFetchError(true);
        pendingModalRefreshRef.current = null;
        return;
      }

      const reservationData = reservationResult.data;

      let equipmentList = selectedList;
      if (!equipmentList || equipmentList.length === 0) {
        if (selectedListBackupRef.current && selectedListBackupRef.current.length > 0) {
          equipmentList = selectedListBackupRef.current;
        } else if (bookingInstruments.bookingInstruments && bookingInstruments.bookingInstruments.length > 0) {
          equipmentList = bookingInstruments.bookingInstruments.map((i) => i.inventoryId);
        }
        if (equipmentList && equipmentList.length > 0) {
          setSelectedList(equipmentList);
        }
      }

      getEventDetails({
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        reservationList: reservationData || [],
        onGoingEventList: [],
        equipmentListOverride: equipmentList,
        isQuickEdit: true,
      });

      setCalendarKey((prev) => prev + 1);
    } catch (error) {
      console.error("Error refreshing data after quick edit:", error);
      snackbarService.show({ type: "error", message: "Failed to refresh calendar", duration: 3000 });
      pendingModalRefreshRef.current = null;
    }
  }, [
    extendedStartDate,
    extendedEndDate,
    selectedStartDate,
    selectedEndDate,
    selectedList,
    getEventDetails,
    getReservationBooking,
    popoverObject,
    bookingInstruments.bookingInstruments,
    setSelectedList,
  ]);

  const displayEditEndFunctionality = () => {
    if (!isTimelineView) return null;

    const eventData = popoverObject?.eventData;
    if (!eventData || Object.keys(eventData).length === 0) return null;

    const userCanManageBooking = isUserCreatorParticipantOrAdmin(storeUser, eventData);
    const isInformation = !!eventData?.isInformationBooking;

    if (userCanManageBooking) {
      return (
        <div style={{ display: "flex" }}>
          {displayCancelBookingButton()}
          {!isInformation && (
            <OwcButton
              variant="primary"
              style={{ marginLeft: "20px" }}
              onClick={() => {
                setPopupEnableStatus(true);
                editBooking(eventData);
              }}
            >
              Open Full Edit
            </OwcButton>
          )}
        </div>
      );
    }

    return null;
  };

  const handlePopoverClose = useCallback(() => {
    setPopoverObject({
      equipmentData: {},
      eventData: {},
    });
  }, []);

  const showStatus = loading || popupLoading || isCancelling || isPopoverFetching;

  const resourcePopoverData = useMemo(
    () => ({ ...popoverObject?.equipmentData, context: popoverObject }),
    [popoverObject],
  );

  const eventPopoverData = useMemo(
    () => ({
      ...popoverObject?.equipmentData,
      context: popoverObject?.eventData,
      bookingEntries: popoverObject?.eventData?.bookingEntries,
    }),
    [popoverObject?.equipmentData, popoverObject?.eventData],
  );

  useEffect(() => {
    const handleOpenCidmDialog = (event) => {
      const detail = event?.detail || {};
      setCidmDialogState({
        open: true,
        groupName: detail.name || "-",
        cidmUrl: detail.url || "",
        infoUrl: detail.info || "",
      });
    };

    document.addEventListener("openCidmDialog", handleOpenCidmDialog);

    return () => {
      document.removeEventListener("openCidmDialog", handleOpenCidmDialog);
    };
  }, []);

  const closeCidmDialog = useCallback(() => {
    setCidmDialogState((current) => ({
      ...current,
      open: false,
    }));
  }, []);

  const previousHalfHour = useMemo(() => getPreviousHalfHourLabel(storeUser?.timezone || "UTC"), [storeUser?.timezone]);

  return (
    <>
      <BackdropPortal show={showStatus} zIndex={BACKDROP_ZINDEX + (popupLoading || isCancelling ? 10 : 0)} />
      {isCancelling && <BookingNotificationStatus onBookingCallback={cancellationCallbackRef.current} />}
      {bookingInstruments.bookingInstruments.length > 0 ? (
        <CustomEventCalendar
          key={calendarKey}
          eventData={eventsData}
          resourceData={resourceData}
          selectedStartDate={extendedStartDate}
          setSelectedStartDate={setSelectedStartDate}
          selectedEndDate={extendedEndDate}
          setSelectedEndDate={setSelectedEndDate}
          originalSelectedStartDate={selectedStartDate}
          originalSelectedEndDate={selectedEndDate}
          setEventsData={setEventsData}
          setResourceData={setResourceData}
          dataTimeZone={dataTimeZone}
          displayTimeZone={displayTimeZone}
          getReservationBooking={getReservationBooking}
          clearPendingReservation={clearPendingReservation}
          updatePendingReservation={updatePendingReservation}
          removeEquipmentAndReservation={removeEquipmentAndReservation}
          pendingReservations={pendingReservations}
          getEventDetails={getEventDetails}
          setloading={setloading}
          loading={loading}
          view={view}
          setView={setView}
          calView={calView}
          setCalView={setCalView}
          siteTimezone={user.timezone}
          manipulatePopoverContent={manipulatePopoverContent}
          newEquipmentIds={newEquipmentIds}
          setNewEquipmentIds={setNewEquipmentIds}
          getLatestEventDetailsOnly={getLatestEventDetailsOnly}
          setCancelStatus={setCancelStatus}
          cancelStatus={cancelStatus}
          deleteResourceId={deleteResourceId}
          setDeleteResourceId={setDeleteResourceId}
          isEquipmentView={isEquipmentView}
          isTimelineView={isTimelineView}
          user={user}
          client={client}
          visibleDatePicker={visibleDatePicker}
          isGroupView={isGroupView}
          handleCreateBookingFromEquipmentView={handleCreateBookingFromEquipmentView}
          listGroupByView={listGroupByView}
          setListGroupByView={setListGroupByView}
          bookingFetchError={bookingFetchError}
          timelineGroupByDefault={timelineGroupByDefault}
          timelineGroupByStorageKey={timelineGroupByStorageKey}
          timelineTimeframeStorageKey={timelineTimeframeStorageKey}
          timelineStorageOptions={timelineStorageOptions}
          onTimelineUpdateBooking={handleTimelineUpdateBooking}
          setPopupEnableStatus={setPopupEnableStatus}
          onCancelCreateFlow={handleCancelCreateFlow}
          isBookingWizard={isBookingWizard}
        />
      ) : (
        isTimelineView && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "8px 16px",
              marginTop: "20px",
              textAlign: "center",
              height: "100%",
            }}
          >
            <span
              style={{
                backgroundColor: "#fefde1",
                border: "1px solid #ccc",
                padding: "8px 12px",
                borderRadius: "2px",
                fontSize: "14px",
              }}
            >
              {NO_EQUIPMENT_FOR_FILTER}
            </span>
          </div>
        )
      )}
      <PopOverModal
        title={
          selectionType === RESOURCE
            ? popoverObject?.equipmentData?.shortIdentifier
            : popoverObject?.equipmentData &&
              Object.keys(popoverObject.equipmentData).length > 0 && <PopoverBookingTitle data={popoverObject} />
        }
        closeTitle="Close"
        data={popoverObject}
        {...dialogProps}
        onDialogCloseCallBack={handlePopoverClose}
        showEmailButton={!isTimelineView}
        actions={displayEditEndFunctionality()}
      >
        {selectionType === RESOURCE && (
          <>
            <PopoverAttributesDetails
              title={ATTRIBUTES_HEADING}
              metaData={
                popoverObject?.equipmentData?.entryType === entryType.cluster
                  ? CLUSTER_DETAILS_ATTRIBUTE_META
                  : STANDALONE_ATTRIBUTE_META
              }
              data={resourcePopoverData}
            />
          </>
        )}
        {selectionType === EVENT && (
          <>
            <PopoverBookingStatusDetail
              data={{
                eventData: {
                  ...popoverObject?.eventData,
                  ...popoverObject?.eventData?.bookingApprovalInfo,
                },
              }}
              allowAssistanceEdit={isBookingAdmin}
              startLoading={() => setPopupLoading(true)}
              stopLoading={() => setPopupLoading(false)}
              onUpdateComplete={handleQuickEditComplete}
              onAssistanceUpdateComplete={handleQuickEditComplete}
            />

            <PopoverAttributesDetails
              title={
                popoverObject?.equipmentData?.entryType === entryType.cluster
                  ? CLUSTER_DETAILS_HEADING
                  : EQUIPMENT_DETAILS_HEADING
              }
              metaData={
                popoverObject?.equipmentData?.entryType === entryType.cluster
                  ? CLUSTER_DETAILS_ATTRIBUTE_META
                  : STANDALONE_ATTRIBUTE_META
              }
              data={eventPopoverData}
            />
          </>
        )}
        {popoverObject?.equipmentData?.entryType === entryType.cluster && (
          <PopOverClusterAgGridTable data={[popoverObject?.equipmentData]} />
        )}
      </PopOverModal>

      {(() => {
        const isInformation = !!popoverObject?.eventData?.isInformationBooking;
        const isEndNowAction = isEndType(dropType) && !isInformation;
        const informationBatchId = popoverObject?.eventData?.batchId;
        // For batch slots we can't know the exact sibling count without
        // calling the BE query, so the dialog warns generically. The actual
        // count is shown in the success snackbar after the cascade resolves.
        const informationContent = informationBatchId
          ? CANCEL_INFORMATION_BATCH_CONFIRMATION
          : CANCEL_INFORMATION_SINGLE_CONFIRMATION;
        return (
          <ConfirmDialog
            open={cancelOpen}
            close={resetCancelState}
            title={isInformation ? CANCEL_INFORMATION_LABEL : isEndNowAction ? END_BOOKING_TITLE : CANCEL_BOOKING_TITLE}
            content={
              isInformation ? informationContent : isEndNowAction ? END_BOOKING_PROMPT : CANCEL_BOOKING_REASON_PROMPT
            }
            secondaryContent={
              isEndNowAction ? `The equipment will be available from ${previousHalfHour} for other users again.` : ""
            }
            approveText={isInformation ? CANCEL_INFORMATION_LABEL : isEndNowAction ? "End now" : DROP_BOOKING_LABEL}
            cancelText="Close"
            showReasonDD={!isInformation && !isEndNowAction}
            reasonValue={cancelReason}
            onReasonChanged={(r) => setCancelReason(r)}
            disableBooking={(isInformation || isEndNowAction ? false : !cancelReason) || isCancelling}
            onApprove={handleCancelBooking}
          />
        );
      })()}
      <CidmGroupDialog
        open={cidmDialogState.open}
        onClose={closeCidmDialog}
        groupName={cidmDialogState.groupName}
        cidmUrl={cidmDialogState.cidmUrl}
        infoUrl={cidmDialogState.infoUrl}
      />
    </>
  );
};

export default compose(
  connect(null, {
    loadBookingInstruments: loadBookingInstrumentsAction,
    loadPendingReservations: loadPendingReservationsAction,
  }),
  withApollo,
)(CalendarMainPage);
